import { Aurelia, autoinject, BindingEngine, dynamicOptions, bindable } from 'aurelia-framework';
import { ResourceService } from './resourceService';

@autoinject
export class ResourceCustomAttribute {

	value: string;

	constructor(
		private element: Element,
		private resourceService: ResourceService,
		private bindingEngine: BindingEngine) {
	}

	bind() {
		this.element.innerHTML = this.resourceService.getResource(this.value);
	}
}

@autoinject
export class ResourceFormatCustomAttribute {

	@bindable key: string;
	@bindable params: string[];

	constructor(
		private element: Element,
		private resourceService: ResourceService,
		private bindingEngine: BindingEngine) {
	}

	bind() {
		this.element.innerHTML = this.resourceService.getResource(this.key, this.params);
	}
}

@autoinject
export class ResourceValueConverter {

	constructor(private resourceService: ResourceService) {
	}

	toView(value, params) {
		return this.resourceService.getResource(value, params);
	}
}

@autoinject
export class OptionalResourceValueConverter {

	constructor(private resourceService: ResourceService) {
	}

	toView(value, params) {
		return this.resourceService.getOptionalResource(value, params);
	}
}
